/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Previous_DifferenceInputs */

const en_compare_event_groups_previous_difference = /** @type {(inputs: Compare_Event_Groups_Previous_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous Difference`)
};

const fr_compare_event_groups_previous_difference = /** @type {(inputs: Compare_Event_Groups_Previous_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Différence précédente`)
};

const de_compare_event_groups_previous_difference = /** @type {(inputs: Compare_Event_Groups_Previous_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige Differenz`)
};

const it_compare_event_groups_previous_difference = /** @type {(inputs: Compare_Event_Groups_Previous_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Differenza precedente`)
};

const ru_compare_event_groups_previous_difference = /** @type {(inputs: Compare_Event_Groups_Previous_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предыдущая разница`)
};

const es_compare_event_groups_previous_difference = /** @type {(inputs: Compare_Event_Groups_Previous_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferencia anterior`)
};

const zh_cn2_compare_event_groups_previous_difference = /** @type {(inputs: Compare_Event_Groups_Previous_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先前差异`)
};

const ja_compare_event_groups_previous_difference = /** @type {(inputs: Compare_Event_Groups_Previous_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前回の差異`)
};

const hi_compare_event_groups_previous_difference = /** @type {(inputs: Compare_Event_Groups_Previous_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछला अंतर`)
};

const pt_pt2_compare_event_groups_previous_difference = /** @type {(inputs: Compare_Event_Groups_Previous_DifferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferença anterior`)
};

/**
* | output |
* | --- |
* | "Previous Difference" |
*
* @param {Compare_Event_Groups_Previous_DifferenceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_previous_difference = /** @type {((inputs?: Compare_Event_Groups_Previous_DifferenceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Previous_DifferenceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_previous_difference(inputs)
	if (locale === "de") return de_compare_event_groups_previous_difference(inputs)
	if (locale === "it") return it_compare_event_groups_previous_difference(inputs)
	if (locale === "ru") return ru_compare_event_groups_previous_difference(inputs)
	if (locale === "es") return es_compare_event_groups_previous_difference(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_previous_difference(inputs)
	if (locale === "ja") return ja_compare_event_groups_previous_difference(inputs)
	if (locale === "hi") return hi_compare_event_groups_previous_difference(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_previous_difference(inputs)
	return en_compare_event_groups_previous_difference(inputs)
});